module.exports = __webpack_public_path__ + "static/media/icon_map_a.1bd4e4c9.svg";